import geoNames from '../data/namesAliases/geoNames.json'


let rerenderFeaturesMethod = '';
export const isIncludesAll = function (arr, target) {
    return target.every(str => arr.includes(str));
};
export const assignGlobalMethods = function (forceUpdateOuter) {
    rerenderFeaturesMethod = forceUpdateOuter;
};

export const rerenderFeatures = function () {
    rerenderFeaturesMethod();
};

export const roundNumber = function (number) {
    return (Math.round(number * 100) / 100);
};

export const areArraysEqual = function (a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;

    for (var i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
};

export const areObjectsEqual = function (x, y) {
    if (x === y) return true;
    // if both x and y are null or undefined and exactly the same

    if (!(x instanceof Object) || !(y instanceof Object)) return false;
    // if they are not strictly equal, they both need to be Objects

    if (x.constructor !== y.constructor) return false;
    // they must have the exact same prototype chain, the closest we can do is
    // test there constructor.

    for (var p in x) {
        if (!x.hasOwnProperty(p)) continue;// eslint-disable-line
        // other properties were tested using x.constructor === y.constructor

        if (!y.hasOwnProperty(p)) return false;// eslint-disable-line
        // allows to compare x[ p ] and y[ p ] when set to undefined

        if (x[p] === y[p]) continue;
        // if they have the same strict value or identity then they are equal

        if (typeof (x[p]) !== 'object') return false;
        // Numbers, Strings, Functions, Booleans must be strictly equal

        if (!areObjectsEqual(x[p], y[p])) return false;
        // Objects and Arrays must be tested recursively
    }

    for (p in y)
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p))// eslint-disable-line
            return false;
    // allows x[ p ] to be set to undefined

    return true;
};

export const sortPropertyIndex = function (items, property, direction, index) {
    const itemsCopied = _.cloneDeep(items);

    function getNumber(value, direction) {
        if (typeof value === 'number' || typeof value === 'string') {
            return +value;
        }
        return direction === 'descending' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    }

    if (direction === 'ascending') {
        return itemsCopied.sort((a, b) => getNumber(a[property][index], direction) -
            getNumber(b[property][index], direction));
    } else if (direction === 'descending') {
        return itemsCopied.sort((a, b) => getNumber(b[property][index], direction) -
            getNumber(a[property][index], direction));
    }
};
export const sortByPropertyNameForStrings = function (items, property, direction) {
    const itemsCopied = _.cloneDeep(items);
    if (direction === 'ascending') {
        return itemsCopied.sort(function (a, b) {
            if (a[property].toLowerCase() > b[property].toLowerCase()) {
                return 1;
            }
            if (a[property].toLowerCase() < b[property].toLowerCase()) {
                return -1;
            }
            return 0;
        });
    } else if (direction === 'descending') {
        return itemsCopied.sort(function (a, b) {
            if (a[property].toLowerCase() > b[property].toLowerCase()) {
                return -1;
            }
            if (a[property].toLowerCase() < b[property].toLowerCase()) {
                return 1;
            }
            return 0;
        });
    }
    return itemsCopied;
};

export const sortByPropertyNameForDates = function (items, property, direction) {
    const itemsCopied = _.cloneDeep(items);
    if (direction === 'ascending') {
        return itemsCopied.sort(function (a, b) {
            return new Date(a[property]) - new Date(b[property]);
        });

    } else if (direction === 'descending') {
        return itemsCopied.sort(function (a, b) {
            return new Date(b[property]) - new Date(a[property]);
        });
    }
    return items;
};

export const copyToClipboard = function (text) {
    console.log('text',text)
    const elem = document.createElement('textarea');
    elem.value = text;
    document.body.appendChild(elem);
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
};

export const sortByPropertyNameForNumbers = function (items, property, direction) {
    const itemsCopied = _.cloneDeep(items);

    function getNumber(stringValue) {
        if (stringValue.length && stringValue.toLowerCase().trim() !== 'no value') {
            return Number(stringValue.split('.').join(''));
        }
        return 999999;
    }

    if (direction === 'ascending') {
        return itemsCopied.sort(function (a, b) {
            return getNumber(a[property]) - getNumber(b[property]);
        });

    } else if (direction === 'descending') {
        return itemsCopied.sort(function (a, b) {
            return getNumber(b[property]) - getNumber(a[property]);
        });
    }
    return itemsCopied;
};

export const exportRowsToFile = function (fileName, rows, fileFormat = 'csv') {
    const fullFileName = `${fileName}.${fileFormat}`;
    let csv = '';
    rows.forEach((row) => {
        const stringFromArray = row ? row.toString().replace(/\t/gi, ' ') : '';
        csv += stringFromArray;
        csv += '\n';
    });

    // for UTF-16
    let cCode;
    const bArr = [];
    bArr.push(255, 254);
    for (let k = 0; k < csv.length; ++k) {
        cCode = csv.charCodeAt(k);
        bArr.push(cCode & 0xff);
        bArr.push(cCode / 256 >>> 0);
    }

    const blob = new Blob([new Uint8Array(bArr)], {
        type: 'text/csv;charset=UTF-16LE;',
    });
    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fullFileName);
    } else {
        const link = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', fullFileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
};

export const sortByNumber = function (unsortedArray) {
    return unsortedArray.sort(function (a, b) {
        if (a > b) {
            return 1;
        }
        if (a < b) {
            return -1;
        }
        return 0;
    });
};

export const getNameAliases = function (featureName) {
    if (featureName === 'geo') {
        return geoNames;
    }
    return {}
};

export const generateRandomString = function (strLength = 15) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < strLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
};

export function getTableColumnWidthActiveColumns(headersWidth, deletedIndexes) {
    if (!headersWidth) {
        return 0;
    }
    return headersWidth.reduce((prev, current, index) => {
        if (!deletedIndexes.includes(index)) {
            return prev + (Math.max(current + 2, 38) * 100) / 100;
        } else {
            return prev;
        }
    }, 0);
}

export function getTableColumnWidth(onRoundedWidth) {
    return Math.max(onRoundedWidth + 2, 38);
}

export function getArrayOfObjectsChangesByPropery(array1, array2, property) {
    const changes = [];
    array1.forEach((newEl, newElIndex) => {
        if (array2[newElIndex] && newEl[property] !== array2[newElIndex][property]) {
            changes.push(newEl);
        }
    });
    return changes;
}

export function addTempBoardData(currentBoard, propertyName, data) {
    if (!currentBoard.tempData) {
        currentBoard.tempData = {};
    }
    currentBoard.tempData[propertyName] = data;
}
